import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { faqs } from '../data/mockData';

export default function FAQ() {
  const [expandedIndex, setExpandedIndex] = useState(0);

  return (
    <div className="max-w-3xl mx-auto space-y-8 animate-in fade-in duration-500 pb-20">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-chalk">Support & FAQ</h1>
        <p className="text-slate-400 mt-2">Common questions about the EduOps product demo.</p>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="glass-panel rounded-2xl overflow-hidden border-slate-800/50">
            <button
              onClick={() => setExpandedIndex(expandedIndex === index ? -1 : index)}
              className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-slate-800/30 transition-colors"
            >
              <span className="font-semibold text-slate-200">{faq.question}</span>
              <SafeIcon 
                icon={expandedIndex === index ? "FiMinus" : "FiPlus"} 
                className={`text-principal transition-transform duration-300 ${expandedIndex === index ? 'rotate-180' : ''}`}
              />
            </button>
            <AnimatePresence>
              {expandedIndex === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="px-6 pb-6 text-slate-400 leading-relaxed text-sm">
                    {faq.answer}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>

      <div className="glass-panel rounded-2xl p-8 bg-blue-900/10 border-blue-500/20 text-center">
        <h3 className="text-xl font-bold text-chalk mb-2">Still have questions?</h3>
        <p className="text-slate-400 mb-6 font-mono text-sm">Our technical specialists are ready to assist with custom implementation plans.</p>
        <button className="bg-principal text-white px-8 py-3 rounded-xl font-semibold shadow-lg shadow-blue-500/20 hover:bg-blue-500 transition-all">
          Contact Demo Team
        </button>
      </div>
    </div>
  );
}